import {Component, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {Router, RouterLink} from "@angular/router";
import {MatIcon} from "@angular/material/icon";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {environment} from "../../../../environments/environment";

interface IMenuItem {name: string, link: string, role: string, icon: string, hr?: boolean, group?: number, tag?: () => number}

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [
    NgClass,
    RouterLink,
    NgForOf,
    MatIcon,
    NgIf
  ],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent implements OnInit, OnDestroy {

  @Input() menuOpened: boolean = false;

  it: number = 0;
  it2: number = 0;

  adminGroups = ['Admin Part'];
  opens = [false];

  bonusCount = 0;


  menuItems: IMenuItem[] = [
    {name: 'Home', link: '/dashboard/index', role: 'all', icon: 'home'},
    {name: 'User Admin', link: '/dashboard/manager', role: 'manager', icon: 'face_3', group: 0},
    {name: 'Roles', link: '/dashboard/manager-role', role: 'manager-role', icon: 'face', group: 0},
    {name: 'Settings', link: '/dashboard/setting', role: 'setting', icon: 'settings', group: 0},
    {name: 'User Admin Log', link: '/dashboard/manager-log', role: 'manager', icon: 'description', group: 0},
    // {name: 'Investors Log', link: '/dashboard/client-log', role: 'client', icon: 'format_list_bulleted', group: 0},
    {name: 'Doc', link: '/dashboard/doc', role: 'doc', icon: 'format_list_bulleted', group: 0},
    {name: 'Social', link: '/dashboard/social', role: 'social', icon: 'social_distance', group: 0},
    {name: 'Reset Token', link: '/dashboard/reset-token', role: 'reset-token', icon: 'lock', group: 0},
    {name: 'Car', link: '/dashboard/car', role: 'car', icon: 'directions_car', group: 0},
    {name: 'Car Tag Type', link: '/dashboard/car-tag-type', role: 'car-tag-type', icon: 'local_shipping', group: 0},
    {name: 'Car Tag', link: '/dashboard/car-tag', role: 'car-tag', icon: 'two_wheeler', group: 0},
    {name: 'Car To Car Tag', link: '/dashboard/car-to-car-tag', role: 'car-to-car-tag', icon: 'car_rental', group: 0},
    {name: 'Translate', link: '/dashboard/translate', role: 'translate', icon: 'hearing', group: 0},
    {name: 'Links', link: '/dashboard/link', role: 'translate', icon: 'link', group: 0},
    {name: 'Gallery', link: '/dashboard/gallery', role: 'translate', icon: 'table', group: 0},
    {name: 'Form', link: '/dashboard/form', role: 'form', icon: 'list', group: 0},
  ]

  read = [ 'all' ];
  write = [ 'all' ];

  get filteredMenuItems() {
    return this.menuItems.filter(item => this.read.includes(item.role));
  }

  constructor(protected router: Router,
              protected httpClient: HttpClient) {

    this.opens = JSON.parse(localStorage.getItem('opens') || '[false]');
  }

  ngOnInit() {

    this.it = setInterval(() => {
      this.updateRoles();
    }, 60 * 1000);
    this.it2 = setInterval(() => {
      this.refreshBonusCount();
    }, 1000);

    this.updateRoles();
    this.refreshBonusCount();
  }

  updateRoles() {

    this.httpClient.get(environment.apiUrl + '/me/modules-my-role', {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
      }
    }).toPromise().then((data: any) => {
      this.read = data.read;
      this.write = data.write;
      localStorage.setItem('managerId', data.managerId);
    }).catch((err) => {
      if (err instanceof HttpErrorResponse) {
        if (err?.error?.error === 'broken_jwt_header'
          || err?.error?.error === 'broken_tfa_jwt_header') {
          localStorage.removeItem('jwtToken');
          document.location = 'auth/login';
        }
      }
      console.error(err);
    });
  }

  hasOptions(items: IMenuItem[], groupId: number) {
    return !!items.find(item => item.group === groupId);
  }

  ngOnDestroy() {
    if (this.it) {
      clearInterval(this.it);
    }
    if (this.it2) {
      clearInterval(this.it2);
    }
  }

  isActive(link: string) {
    return this.router.url === link;
  }


  refreshBonusCount() {
    const query = {
      orderBy: 'createdAt',
      orderDirection: 'desc',
      filterStatus: 2,
      perPage: 10000
    };


  }

  toggleOpen(id: number) {
    this.opens[id] = !this.opens[id];
    localStorage.setItem('opens', JSON.stringify(this.opens));
  }
}
